<template>
  <div>
    <demand-table :changeOrderCode="changeOrderCode" :disabled="disabled"/>
  </div>
</template>

<script>
import DemandTable from './components/demand-table/index'
export default {
  components: {
    DemandTable
  },
  props: {
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {}
  }
}
</script>
